import React from 'react';
import LetterHistory from 'modules/letter-history';
import { ShowIf } from 'components/utils';
import {
  KetQuaXuLyDon
} from 'modules/giai-quyet-don/subView';
import { LetterProcessingWorkFlow, GiaiQuyetDonThu } from 'api';
import { GetTrangThaiDonTheoDonVi } from 'modules/login/GetTrangThaiDonTheoDonVi';
import { CheckQuyenThaoTacXuLy } from 'modules/login/CheckQuyenThaoTacXuLy';
import { FormXuLyHoacGiaiQuyet } from 'modules/handle-letters/xu-ly-don';
import {
  NhiemVuTTXM
} from 'modules/handle-letters/xu-ly-don/form-giai-quyet';
import {
  ThongTinYeuCauKTDX
} from 'modules/handle-letters/xu-ly-don/form-kiem-tra-de-xuat';

class TinhTrangDon extends React.Component {
	constructor(props, context) {
    super(props, context);
    this.state = {
      donId: '',
      trangThaiDonDonVi: {},
      alias: '',
      thongTinXuLyGiaiQuyet: {},
      title: '',
      processType: '',
      thongTinGiaiQuyetDonPlus: {},
      dataKetQuaXuLyDon: {},
      donDangXuLy: false
    }
  }

  componentWillReceiveProps(nextProps) {
  	if (nextProps.data != this.props.data) {
      this.state.dataKetQuaXuLyDon.thamQuyenGiaiQuyet = nextProps.data.thamQuyenGiaiQuyetInfo ? nextProps.data.thamQuyenGiaiQuyetInfo.ten : '';
      this.state.trangThaiDonDonVi = GetTrangThaiDonTheoDonVi(nextProps.data.trangThaiDonInfo);
      this.state.donId = nextProps.data.donId;
  		this.setState({...this.state});

      this.getThongTinXuLyHoacGiaiQuyet(nextProps.data.donId);
      if (nextProps.data.thongTinGiaiQuyetDonId) {
        // Lay thong tin giai quyet don Id neu co
        GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: nextProps.data.thongTinGiaiQuyetDonId }).then(dataGiaiQuyetDon => {
          if (dataGiaiQuyetDon.data)
            this.setState({
              thongTinGiaiQuyetDonPlus: dataGiaiQuyetDon.data
            });
        })
      }
  	}
  }

  getThongTinXuLyHoacGiaiQuyet(donId) {
    LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(res => {
      if (res.data) {
        this.state.thongTinXuLyGiaiQuyet = res.data.thongTinXuLyInfo;
        this.state.alias = res.data.nextFormInfo.alias;
        if (this.state.alias) {
          this.state.title = 'Thông tin đã xử lý';
        }
        this.setState({...this.state});
      }
    }).catch(error => {
      if (error.response) {
        if (error.response.data.errors[0].code == 'DATA_NOT_FOUND') {
          this.getThongTinGiaiQuyetDon(donId);
        }
      }
    });
  }

  getThongTinGiaiQuyetDon(donId) {

    GiaiQuyetDonThu.actions.getLichSuGiaiQuyetDon.request({ id: donId }).then(res => {
      if (res.data) {

        let info = res.data;
        let title = '';
        let alias = '';
        let processType = '';

        // Set title cho form giai quyet hoac kiem tra de xuat
        if (this.state.donDangXuLy) {

          if (this.state.processTypeValue == 'THAM_TRA_XAC_MINH' || this.state.processTypeValue == 'GIAI_QUYET_DON') {
            if (this.state.alias == 'CanBoTTXMAction')
              title = 'Báo cáo thẩm tra xác minh';
            else
              title = 'Thông tin giải quyết';
          } else if (this.state.processTypeValue == 'KIEM_TRA_DE_XUAT') {
            if (this.state.alias == 'canBoKiemTraDeXuatKhongQuyTrinh') {
              title = 'Báo cáo kết quả kiểm tra';
            } else {
              title = 'Thông tin đề xuất';
            }
          }
          alias = this.state.alias;
          processType = this.state.processTypeValue;
        } else {

          if (info.processType.type == 'KIEM_TRA_DE_XUAT') {

            title = 'Thông tin đã đề xuất';

            if (info.nextFormInfo.alias == 'canBoKiemTraDeXuat' || info.nextFormInfo.alias == 'canBoKiemTraDeXuatKhongQuyTrinh') {

              title = 'Báo cáo kết quả kiểm tra';
            }
          } else {

            if (info.nextFormInfo.alias == 'CanBoGiaiQuyetDonAction' ||
            info.nextFormInfo.alias == 'CanBoGiaiQuyetDonLapDuThaoAction' ||
            info.nextFormInfo.alias == 'CanBoTTXMAction') {
              let lb2 = this.props.data.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
              title = 'Báo cáo kết quả xác minh'+lb2;
            } else {

              title = 'Thông tin đã giải quyết';
            }
          }

          processType = info.processType.type;
          alias = info.nextFormInfo.alias;
        }

        this.setState({
          alias: alias,
          title: title,
          processTypeValue: processType,
          thongTinXuLyGiaiQuyet: info
        });

        this.state.dataKetQuaXuLyDon.yKienXuLy = res.data.thongTinGiaiQuyetDonInfo.yKienXuLyDon;
        this.state.dataKetQuaXuLyDon.phongBanGiaiQuyet = res.data.phongBanGiaiQuyetInfo.ten;
        this.setState({...this.state});
      }
    }).catch(error => {
      if (error.response) {
        console.log(error.response.data.errors[0].detail);
      }
    })
  }

  viewInfomationWork() {
    if (this.state.processTypeValue == 'THAM_TRA_XAC_MINH') {
      switch (this.state.alias) {
        case 'CanBoNhapLieuTTXMAction':
        case 'LanhDaoTTXMAction':
          return (
            <div className="page-wrapper">
              <NhiemVuTTXM
                thongTinGiaiQuyetDonPlus={this.state.thongTinGiaiQuyetDonPlus}
                thongTinXuLyGiaiQuyet={this.state.thongTinXuLyGiaiQuyet}
                listTaiLieuVanThuGiaiQuyetDon={this.props.data.listTaiLieuVanThuGiaiQuyetDon}
                donInfo = {this.props.data}
              />
            </div>
          )
      }
    } else if (this.state.processTypeValue == 'KIEM_TRA_DE_XUAT') {
      if (this.state.alias == 'canBoKiemTraDeXuat') {
        return (
          <div className="page-wrapper">
            <ThongTinYeuCauKTDX
              thongTinYeuCauKiemTraDeXuat={this.state.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo}
              listTaiLieuVanThuKiemTraDeXuat={this.props.data.listTaiLieuVanThuKiemTraDeXuat}
              showTable={
                ((this.state.alias == 'vanThuKiemTraDeXuat') ||
                (this.state.alias == 'lanhDaoKiemTraDeXuat')) ||
                (this.state.donDangXuLy && this.state.alias == 'canBoKiemTraDeXuatKhongQuyTrinh')}/>
          </div>
        )
      } else {
        return (
          <div className="page-wrapper">
            <ThongTinYeuCauKTDX
              thongTinYeuCauKiemTraDeXuat={this.state.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo}
              listTaiLieuVanThuKiemTraDeXuat={this.props.data.listTaiLieuVanThuKiemTraDeXuat}
              showTable={ false}/>
          </div>
        )
      }
    }
  }

  render() {
  	return (
  		<div>
	  		{ this.props.data.donId ?
	          <LetterHistory donId={this.props.data.donId} onChange={() => {}} ma={this.props.data.ma} />
	        : ''
	      }

        <ShowIf condition={this.state.alias == 'CanBoGiaiQuyetDonAction' ||
          this.state.alias == 'CanBoGiaiQuyetDonLapDuThaoAction' ||
          this.state.alias == 'CanBoGiaiQuyetDonLapDuThaoKhongQuyTrinh' ||
          this.state.alias == 'CanBoGiaiQuyetDonKhongQuyTrinh'}>
            <div className="page-wrapper">
              <KetQuaXuLyDon status={false}
                {...this.state.dataKetQuaXuLyDon}
                donInfo={this.props.data}
                dataGiaiQuyet = {this.state.thongTinXuLyGiaiQuyet}
                hideBorder={true}
              />
            </div>
        </ShowIf>

        {this.viewInfomationWork()}
        { (this.state.donDangXuLy && CheckQuyenThaoTacXuLy(this.state.canBoDangXuLy)) ||
          (!this.state.donDangXuLy && (this.state.alias || this.state.trangThaiDonDonVi.ketQuaType == 'DINH_CHI')) ?
            <div className="page-wrapper">
              <FormXuLyHoacGiaiQuyet
                ma={this.props.data.ma}
                lyDoDinhChi={this.props.data.lyDoDinhChi}
                loaiDonGiaTri={this.props.data.loaiDon}
                thongTinXuLyGiaiQuyet={this.state.thongTinXuLyGiaiQuyet}
                thongTinYeuCauKiemTraDeXuat={this.state.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo}
                title={this.state.title}
                alias={this.state.alias}
                donId={this.props.data.donId}
                listNextStates={[]}
                donDangXuLy={this.state.donDangXuLy}
                tongSoLuotTCD={this.props.data.tongSoLuotTCD}
                thongTinGiaiQuyetDonId={this.props.data.thongTinGiaiQuyetDonId}
                processType={this.state.processTypeValue}
                listTaiLieuVanThu={this.props.data.listTaiLieuVanThu}
                listTaiLieuVanThuKiemTraDeXuat={this.props.data.listTaiLieuVanThuKiemTraDeXuat}
                listTaiLieuVanThuGiaiQuyetDon={this.props.data.listTaiLieuVanThuGiaiQuyetDon}
                listTaiLieuVanThuGiaiQuyetDonView={this.props.data.listTaiLieuVanThuGiaiQuyetDonView}
                listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM={this.props.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
                listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView={this.props.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
                listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.props.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
                listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.props.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
                listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.props.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
                listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.props.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
                listTaiLieuVanThuBoSungHoSo = {this.props.data.listTaiLieuVanThuBoSungHoSo}
                thongTinGiaiQuyetDonPlus={this.state.thongTinGiaiQuyetDonPlus}
                trangThaiDonDonVi={this.state.trangThaiDonDonVi}
                bindValidator={this}
                donInfo={this.props.data}
                data = {this.props.data}
                pageType="CHI_TIET_DON"/>
            </div>
          :''
        }
	    </div>
  	)
  }
}

TinhTrangDon.defaultProps = {
	data: {}
}

export default TinhTrangDon;


// WEBPACK FOOTER //
// ./src/components/modules/reception/TinhTrangDon.jsx